import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export { parameterAwareDebounce } from "./parameterAwareDebounce";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

let isMac = false;

if (typeof navigator !== "undefined") {
  const { platform } = navigator;
  if (
    platform?.startsWith("Mac") ||
    platform?.startsWith("iPhone") ||
    platform?.startsWith("iPad")
  ) {
    isMac = true;
  }
}

export { isMac };
